module.exports = __webpack_public_path__ + "img/yjey-3.3eaef82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yjey-3.jpg
// module id = KXaN
// module chunks = 0